module.exports = __webpack_public_path__ + "static/media/OT.636898e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ministries/OT.svg
// module id = 250
// module chunks = 0